(function (window) {
  'use strict';

  function isSetProduct(optionsWithValues) {
    if (!optionsWithValues || !optionsWithValues.length) return false;
    var styleOpt = null;
    for (var i = 0; i < optionsWithValues.length; i++) {
      var n = (optionsWithValues[i].name || '').toLowerCase();
      if (n === 'style' || n === 'modelo') {
        styleOpt = optionsWithValues[i];
        break;
      }
    }
    if (!styleOpt || !styleOpt.values) return false;
    var hasTop = false;
    var hasBottom = false;
    for (var j = 0; j < styleOpt.values.length; j++) {
      var v = String(styleOpt.values[j]);
      if (v.indexOf('Top') !== -1) hasTop = true;
      if (v.indexOf('Bottom') !== -1 || v.indexOf('Calcinha') !== -1) hasBottom = true;
    }
    return hasTop && hasBottom;
  }

  function sizeOptionName(optionsWithValues) {
    if (!optionsWithValues) return null;
    for (var i = 0; i < optionsWithValues.length; i++) {
      var n = optionsWithValues[i].name || '';
      var d = n.toLowerCase();
      if (d === 'size' || d === 'tamanho') return n;
    }
    return null;
  }

  function sizeValues(optionsWithValues) {
    var name = sizeOptionName(optionsWithValues);
    if (!name) return [];
    for (var i = 0; i < optionsWithValues.length; i++) {
      if (optionsWithValues[i].name === name) {
        return (optionsWithValues[i].values || []).slice();
      }
    }
    return [];
  }

  function optionIndex(optionsWithValues, predicate) {
    for (var i = 0; i < optionsWithValues.length; i++) {
      if (predicate(optionsWithValues[i].name || '')) return i;
    }
    return -1;
  }

  function styleMatches(value, styleHint) {
    if (!styleHint) return true;
    var v = String(value).toLowerCase();
    var h = String(styleHint).toLowerCase();
    if (h.indexOf('top') !== -1) return v.indexOf('top') !== -1;
    if (h.indexOf('bottom') !== -1 || h.indexOf('calcinha') !== -1) {
      return v.indexOf('bottom') !== -1 || v.indexOf('calcinha') !== -1;
    }
    return v === h;
  }

  /** Aceita options string[] (legado) ou {name,values}[] (product.js atual). */
  function normalizeOptions(rawOptions, variants) {
    var raw = rawOptions || [];
    if (!raw.length) return [];
    if (typeof raw[0] === 'object' && raw[0] !== null && raw[0].name) {
      return raw.map(function (opt) {
        return { name: String(opt.name), values: (opt.values || []).slice() };
      });
    }
    return raw.map(function (name, idx) {
      var values = [];
      (variants || []).forEach(function (v) {
        var opts = v.options || [];
        var val = opts[idx];
        if (val != null && values.indexOf(val) === -1) values.push(val);
      });
      return { name: String(name), values: values };
    });
  }

  function findVariant(variants, sel) {
    if (!variants || !sel) return null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.available) continue;
      var opts = v.options || [];
      var sizeOk = !sel.size;
      var styleOk = !sel.style;
      for (var j = 0; j < opts.length; j++) {
        if (sel.size && opts[j] === sel.size) sizeOk = true;
        if (sel.style && styleMatches(opts[j], sel.style)) styleOk = true;
      }
      if (sizeOk && styleOk) return v;
    }
    return null;
  }

  function findVariantId(variants, sel) {
    var v = findVariant(variants, sel);
    return v ? v.id : null;
  }

  /** Primeira variante disponível do estilo (Top / Bottom / Calcinha). */
  function firstAvailableByStyle(variants, styleHint) {
    return findVariant(variants, { style: styleHint });
  }

  function buildAddPayload(ids) {
    var items = [];
    for (var i = 0; i < (ids || []).length; i++) {
      items.push({ id: ids[i], quantity: 1 });
    }
    return { items: items };
  }

  function parseProductJson(json) {
    json = json || {};
    var variants = json.variants || [];
    var owv = json.options_with_values;
    if (!owv || !owv.length) {
      owv = normalizeOptions(json.options, variants);
    } else {
      owv = normalizeOptions(owv, variants);
    }
    return {
      id: json.id,
      handle: json.handle,
      title: json.title,
      featured_image: json.featured_image != null ? json.featured_image : null,
      price: json.price,
      options_with_values: owv,
      variants: variants,
      siblings: json.siblings || []
    };
  }

  window.EmpressQuickBuyLib = {
    isSetProduct: isSetProduct,
    sizeOptionName: sizeOptionName,
    sizeValues: sizeValues,
    findVariant: findVariant,
    findVariantId: findVariantId,
    firstAvailableByStyle: firstAvailableByStyle,
    buildAddPayload: buildAddPayload,
    parseProductJson: parseProductJson,
    normalizeOptions: normalizeOptions,
    styleMatches: styleMatches,
    optionIndex: optionIndex
  };
})(typeof window !== 'undefined' ? window : globalThis);
